module.exports = "https://de18y2hs3hlxs.cloudfront.net/ea0f2244-3733-4462-8521-3c67071db2f1/images/notepad.png?75405c954d83b33e90b18b75fbe7ed89";